import { render, staticRenderFns } from "./ai-product-settings.vue?vue&type=template&id=247b79c1&scoped=true&"
import script from "./ai-product-settings.vue?vue&type=script&lang=js&"
export * from "./ai-product-settings.vue?vue&type=script&lang=js&"
import style0 from "./ai-product-settings.vue?vue&type=style&index=0&id=247b79c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247b79c1",
  null
  
)

export default component.exports